import { AiChatService, DocumentationSearchResponseDto } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const searchDocumentationTool: ToolDefinition = {
  name: 'search_documentation',
  description: 'Search Sifflet platform documentation. Use for questions about features, setup, configuration, usage, how-to guides, or how features work. Returns relevant documentation snippets.',
  input_schema: {
    type: 'object',
    properties: {
      query: {
        type: 'string',
        description: 'Natural language query. Be specific about what user is asking.',
      },
      numberDocs: {
        type: 'integer',
        description: 'Number of snippets to retrieve (default: 3, max: 10)',
      },
    },
    required: ['query'],
  },
};

/**
 * Execute the search_documentation tool
 */
export async function executeSearchDocumentation(
  params: { query: string; numberDocs?: number; },
): Promise<{ documents: string[] } | { error: string }> {
  try {
    const result: DocumentationSearchResponseDto = await callWithContext('sifflet-ai-chat', () => AiChatService.searchDocumentation({
      requestBody: {
        query: params.query,
        numberDocs: params.numberDocs || 3,
      },
    }));

    return {
      documents: result.documents || [],
    };
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default searchDocumentationTool;
